import {ApiService} from "../api";
import {Projects} from "../../types";
import {AxiosResponse} from "axios";
import {ProjectDTO} from "../../types/DTOs/ProjectDTO";

export class ProjectAPI extends ApiService {
    private constructor() {
        super();
    }

    async getProjects(): Promise<Projects[]> {
        const response: AxiosResponse<Projects[]> = await this.api.get('/project');
        return response.data;
    }

    async createProjects(data: ProjectDTO): Promise<Projects> {
        const response: AxiosResponse<Projects> = await this.api.post('/project', data);
        return response.data;
    }

    async updateProjects(id: string, data: Partial<ProjectDTO>): Promise<Projects> {
        const response: AxiosResponse<Projects> = await this.api.put(`/project/${id}`, data);
        return response.data;
    }

    async deleteProjects(id: string): Promise<void> {
        await this.api.delete(`/project/${id}`);
    }
}